'use strict';

var _asyncToGenerator = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _wrapAsyncGenerator = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncIterator = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _asyncGeneratorDelegate = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

var errCode = require('err-code');

var browserStreamToIt = require('browser-readablestream-to-it');

var itPeekable = require('it-peekable');

var map = require('it-map');

var _require = require('./utils'),
    isBytes = _require.isBytes,
    isBlob = _require.isBlob,
    isReadableStream = _require.isReadableStream,
    isFileObject = _require.isFileObject,
    mtimeToObject = _require.mtimeToObject,
    modeToNumber = _require.modeToNumber; // eslint-disable-next-line complexity

/**
 * @typedef {import('ipfs-core-types/src/files').ToContent} ToContent
 */

/**
 * @template {Blob|AsyncIterable<Uint8Array>} Content
 * @param {import('ipfs-core-types/src/files').ImportSource} input
 * @param {(content:ToContent) => Content|Promise<Content>} normaliseContent
 * @returns {AsyncIterable<import('ipfs-core-types/src/files').Entry<Content>>}
 */
// eslint-disable-next-line complexity


module.exports = /*#__PURE__*/function () {
  var _normaliseInput = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input, normaliseContent) {
    var peekable, _yield$_awaitAsyncGen, value, done;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(input === null || input === undefined)) {
              _context.next = 2;
              break;
            }

            throw errCode(new Error("Unexpected input: ".concat(input)), 'ERR_UNEXPECTED_INPUT');

          case 2:
            if (!(typeof input === 'string' || input instanceof String)) {
              _context.next = 6;
              break;
            }

            _context.next = 5;
            return toFileObject(input.toString(), normaliseContent);

          case 5:
            return _context.abrupt("return");

          case 6:
            if (!(isBytes(input) || isBlob(input))) {
              _context.next = 10;
              break;
            }

            _context.next = 9;
            return toFileObject(input, normaliseContent);

          case 9:
            return _context.abrupt("return");

          case 10:
            // Browser ReadableStream
            if (isReadableStream(input)) {
              input = browserStreamToIt(input);
            } // Iterable<?>


            if (!(input[Symbol.iterator] || input[Symbol.asyncIterator])) {
              _context.next = 32;
              break;
            }

            /** @type {any} peekable */
            peekable = itPeekable(input);
            /** @type {any} value **/

            _context.next = 15;
            return _awaitAsyncGenerator(peekable.peek());

          case 15:
            _yield$_awaitAsyncGen = _context.sent;
            value = _yield$_awaitAsyncGen.value;
            done = _yield$_awaitAsyncGen.done;

            if (!done) {
              _context.next = 21;
              break;
            }

            return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator([]), _awaitAsyncGenerator), "t0", 20);

          case 20:
            return _context.abrupt("return");

          case 21:
            peekable.push(value); // (Async)Iterable<Number>
            // (Async)Iterable<Bytes>

            if (!(Number.isInteger(value) || isBytes(value))) {
              _context.next = 26;
              break;
            }

            _context.next = 25;
            return toFileObject(peekable, normaliseContent);

          case 25:
            return _context.abrupt("return");

          case 26:
            if (!(isFileObject(value) || isBlob(value) || typeof value === 'string' || value instanceof String)) {
              _context.next = 29;
              break;
            }

            return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(map(peekable, function (value) {
              return toFileObject(value, normaliseContent);
            })), _awaitAsyncGenerator), "t1", 28);

          case 28:
            return _context.abrupt("return");

          case 29:
            if (!(value[Symbol.iterator] || value[Symbol.asyncIterator] || isReadableStream(value))) {
              _context.next = 32;
              break;
            }

            return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(map(peekable, function (value) {
              return toFileObject(value, normaliseContent);
            })), _awaitAsyncGenerator), "t2", 31);

          case 31:
            return _context.abrupt("return");

          case 32:
            if (!isFileObject(input)) {
              _context.next = 36;
              break;
            }

            _context.next = 35;
            return toFileObject(input, normaliseContent);

          case 35:
            return _context.abrupt("return");

          case 36:
            throw errCode(new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');

          case 37:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  function normaliseInput(_x, _x2) {
    return _normaliseInput.apply(this, arguments);
  }

  return normaliseInput;
}();
/**
 * @template {Blob|AsyncIterable<Uint8Array>} Content
 * @param {import('ipfs-core-types/src/files').ToEntry} input
 * @param {(content:ToContent) => Content|Promise<Content>} normaliseContent
 * @returns {Promise<import('ipfs-core-types/src/files').Entry<Content>>}
 */


function toFileObject(_x3, _x4) {
  return _toFileObject.apply(this, arguments);
}

function _toFileObject() {
  _toFileObject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input, normaliseContent) {
    var path, mode, mtime, content, file;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // @ts-ignore - Those properties don't exist on most input types
            path = input.path, mode = input.mode, mtime = input.mtime, content = input.content;
            file = {
              path: path || '',
              mode: modeToNumber(mode),
              mtime: mtimeToObject(mtime)
            };

            if (!content) {
              _context2.next = 8;
              break;
            }

            _context2.next = 5;
            return normaliseContent(content);

          case 5:
            file.content = _context2.sent;
            _context2.next = 12;
            break;

          case 8:
            if (path) {
              _context2.next = 12;
              break;
            }

            _context2.next = 11;
            return normaliseContent(input);

          case 11:
            file.content = _context2.sent;

          case 12:
            return _context2.abrupt("return", file);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _toFileObject.apply(this, arguments);
}